<section class="headerOptions">
  @if (canExport) {
    <button class="headerOptions__option" (click)="export()">
      <img class="headerOptions__icon icon-export" [src]="EIconPath.EXPORT_EXPORT" />
      {{ 'export' | ppTranslate }}
    </button>
  }

  @if (canCopy) {
    <button class="headerOptions__option" (click)="copyPoint()">
      <img [src]="EIconPath.POINT_INTERACTION_COPY" class="headerOptions__icon icon-copy" />
      {{ 'copy' | ppTranslate }}
    </button>
  }

  @if (canMove) {
    <button class="headerOptions__option" (click)="movePoint()">
      <img [src]="EIconPath.POINT_INTERACTION_MOVE" class="headerOptions__icon icon-move" />
      {{ 'move' | ppTranslate }}
    </button>
  }

  <button class="headerOptions__option" (click)="linkPoint()">
    <img [src]="EIconPath.ICON_COPY_LINK_24" class="headerOptions__icon icon-link" />
    {{ 'copy_link_to_point' | ppTranslate }}
  </button>

  @if (canDelete) {
    <hr class="headerOptions__hr" />
  }

  @if (canDelete) {
    <button
      class="headerOptions__option headerOptions__option--delete"
      (click)="deletePoint()"
      >
      <img
        class="headerOptions__icon icon__delete"
        [src]="EIconPath.INTERACTION_DELETE_ATTACHMENT_ICON"
        />
      {{ 'delete_point' | ppTranslate }}
    </button>
  }
</section>
